module.exports = __webpack_public_path__ + "static/img/image.b8708fd0.png";